import { useState, useRef, useEffect } from "react";
import { Col, Container, Row, Tab, Tabs, Accordion } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import InterestedUsers from "../../InterestedUsers";
import OperatorRatingSidebar from "components/operator/OperatorRatingSidebar";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import OverView from "./tabs/Overview";
import Itinerary from "./tabs/Itinerary";
import SafariInclusions from "./tabs/SafariInclusions";
import SafarieGettingThere from "./tabs/SafariGettingThere";
import Policy from "./tabs/Policy";
import FaqSafari from "./tabs/FaqSafari";
import Discussion from "../common/Discussion";

const ShareSafariFixed = () => {
    const { safariViewData } = useSharedSafariContext();
    const [key, setKey] = useState("overview");
    const operatorData = {
        google_rating: 4.7,
        google_review_count: 150,
        slug: "operator-xyz",
        business_name: "Operator XYZ",
        id: 1,
    };
    const reviewsData = [
        { user: { name: "Amit Sharma", user_handle: "amit123" }, rating: 5, review: "Excellent service!" },
        { user: { name: "Rohan Das", user_handle: "rohan456" }, rating: 4, review: "Very good experience." },
    ];
    const user = { id: 10 };


    return (
        <>
            <section className="  bg-white ">
                <Container fluid="xxl">
                    <Row className="row packageSfari">
                        <Col lg={12}>

                            <Row className="mt-5 itenary_tabs">
                                <Col xl={11} lg={12} className=" safartabs position-relative">
                                <div className="overflow-auto w-100 hide-scrollbar">
                                    <Tabs
                                        id="myTab"
                                        activeKey={key}
                                        onSelect={(k) => setKey(k)}
                                        className="nav nav-tabs slider_packagemobile d-flex gap-2 flex-nowrap">
                                        <Tab eventKey="overview" title="Discussion" className="nav-item"></Tab>
                                        <Tab eventKey="itinerary" title="Itinerary" className="nav-item"></Tab>
                                        <Tab eventKey="inclusions" title="Inclusions" className="nav-item"></Tab>
                                        <Tab eventKey="getting-there" title="Getting There" className="nav-item"></Tab>
                                        <Tab eventKey="policy-info" title="Policy Info" className="nav-item"></Tab>
                                        <Tab eventKey="faq" title="FAQ" className="nav-item"></Tab>
                                    </Tabs>
                                    </div>
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="safari_wrapper mb-5 margin_bottomfooter">
                <Container fluid="xxl">
                    <Row className="mb-5 mb-lg-5  mt-3 itenary_tabs"    >
                        <Col xs={12} xxl={9} xl={9} className=" safartabs position-relative">
                            <div className="">
                                {key === "overview" && (
                                    <>
                                        <OverView safariViewData={safariViewData} />
                                        <Discussion />
                                    </>
                                )}

                                {key === "itinerary" && (
                                    <Itinerary safariViewData={safariViewData} />
                                )}
                                {key === "inclusions" && (
                                    <SafariInclusions safariViewData={safariViewData} />
                                )}
                                {key === "getting-there" && (

                                    <SafarieGettingThere safariViewData={safariViewData} />

                                )}
                                {key === "policy-info" && (
                                    <Policy safariViewData={safariViewData} />
                                )}
                                {key === "faq" && (
                                    <FaqSafari safariViewData={safariViewData} />
                                )}
                            </div>

                        </Col>
                        <Col xs={12} xxl={3} xl={3} className="mb-lg-0 mb-3">
                            <InterestedUsers />
                            {/* <OperatorRatingSidebar operator={operatorData} reviews={reviewsData} user={user} /> */}
                        </Col>
                    </Row>
                    <Row className="pb-5 d-lg-none">
                        <Col className="col-12 text-center">
                            <div className="joinshareView mt-md-0 mt-3">
                                <Link
                                    to="/sharesafari"
                                    className="btn_shareView pakage"
                                    data-pjax="0"
                                >
                                    {" "}
                                    <i className="fa-solid fa-arrow-left me-2"></i> Back
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ShareSafariFixed;
